import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pushAPI } from '../../services/api';

export default function OnlineUsersLink() {
  const [count, setCount] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let active = true;
    let pending = false;
    let forbidden = false;
    const controller = new AbortController();
    const refresh = async () => {
      if (pending || forbidden) return;
      pending = true;
      try {
        const { data } = await pushAPI.currentUsers(controller.signal);
        if (active) {
          setCount(data.total);
          setUnavailable(false);
        }
      } catch (err) {
        if (active) {
          if (err.response?.status === 403) {
            forbidden = true;
            setCount(null);
          }
          setUnavailable(true);
        }
      } finally {
        pending = false;
      }
    };
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => {
      active = false;
      clearInterval(interval);
      controller.abort();
    };
  }, []);

  return (
    <Link to="/current-users" className="footer-online-users">
      <span aria-live="polite">
        {unavailable ? '在线人数暂不可用' : count === null ? '正在获取在线人数…' : <>当前在线 <strong>{count}</strong> 人</>}
      </span>
    </Link>
  );
}
